import { render, staticRenderFns } from "./ExpertApproval.vue?vue&type=template&id=0d90094e&"
import script from "./ExpertApproval.vue?vue&type=script&lang=js&"
export * from "./ExpertApproval.vue?vue&type=script&lang=js&"
import style0 from "./ExpertApproval.vue?vue&type=style&index=0&id=0d90094e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports